export default "__VITE_ASSET__af5bc215__"